// extracted by mini-css-extract-plugin
export default {"content":"CUFTYIachXzD2iV_kJwe","title":"eqLfAZ1XbGenPhAbWp9A","agreementButton":"JZpBbd20Zc4VCsCikUTQ","products":"O52FlnSh246VSwynJapA"};